
import Typography from "@mui/material/Typography";
import noData from '../../../assets/images/nodata.png';
import "./noDataFound.scss";
import { styled, useTheme } from "@mui/material/styles";

const NoDataFound = (props) => {
    const theme = useTheme();
    return ( 
        <Typography className="noData-search-blk" component={'div'}>
            <Typography component={'div'}>
                <img src={noData} alt="No Data Found" className="no-data-img" />
                <Typography sx={{color: theme.palette.customColor.textDark}} component={'div'} className="no-data-msg">{props.text ? props.text : 'No data found'}</Typography>
            </Typography>
        </Typography>
    )
}

export default NoDataFound ;
